/**
 * UI search type modes for controlling interface elements
 * Used to enable/disable different search UI sections
 */
export enum SearchTypeMode {
  TEXT_SEARCH = "text_search",
  LOCATION_SEARCH = "location_search",
  IMAGE_SEARCH = "image_search",
}
